function formatDate(date) {
    const monthNames = [
        "january", "february", "march", "april", "may", "june",
        "july", "august", "september", "october", "november", "december"
    ];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    let month = monthNames[monthIndex];

    return `${month} ${day}`;
}

function getThirdMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay() + 1) % 7) + 14);
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}

function getLastMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month, 0);
    d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}

function getFirstMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay()) % 7));
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}

function getSecondMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay() + 1) % 7) + 7);
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}

function getThanksgivingDay(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay() + 4) % 7) + 21);
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}

function calculateEstimatedRange() {

    const nowDate = new Date();
    const startDate = new Date(nowDate);
    const endDate = new Date(nowDate);
    
    const holidays = [
        '01-01', // New Year's Day
        getThirdMonday('01'), // Martin Luther King Jr. Day
        getThirdMonday('02'), // Presidents' Day
        getLastMonday('05'),  // Memorial Day
        '07-04',              // Independence Day
        getFirstMonday('09'), // Labor Day
        getSecondMonday('10'),// Columbus Day
        '11-11',              // Veterans Day
        getThanksgivingDay('11'), // Thanksgiving Day
        '12-25'               // Christmas Day
    ];

    function addBusinessDays(date, count) {
        let added = 0;
        const result = new Date(date);
        while (added < count) {
            result.setDate(result.getDate() + 1);
            const dayOfWeek = result.getDay();
            const month = String(result.getMonth() + 1).padStart(2, '0');
            const day = String(result.getDate()).padStart(2, '0');
            const formatted = `${month}-${day}`;
            if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(formatted)) {
                added++;
            }
        }
        return result;
    }

    const bestCase = addBusinessDays(startDate, 5);
    const worstCase = addBusinessDays(endDate, 7);

    const style = document.createElement('style');
    style.type = 'text/css';

    style.innerHTML = `
    #firstShippingDate::before {
        content: "${formatDate(bestCase)}";
        display: block;
    }
        #secondShippingDate::before {
        content: "${formatDate(worstCase)}";
        display: block;
    }
    `;
    document.head.appendChild(style);
}

document.addEventListener('DOMContentLoaded', () => {
    calculateEstimatedRange();
    console.log('Estimated shipping date range calculated and styles applied.');
});